import { ADDRESS_OPTIONS, AddressTypes, EmailTypes, PhoneTypes } from '@common/Constants';

import { participantsOptions } from '../Constants';
import { formatStringDateForRequest } from '../OrderSummaryDialog';

const initialValues = {
  isBookingPerson: participantsOptions.participant,
  billingAddressRadio: ADDRESS_OPTIONS.noAlternative,
  communicationAddressRadio: ADDRESS_OPTIONS.noAlternative,
  hasIliasAccount: false,
  iliasUsername: '',
  generalInformation: {
    title: '0',
    academicTitle: '1',
    gender: '4',
    firstName: '',
    lastName: '',
    language: '1',
    company: '',
    birthDate: null,
    birthPlace: '',
    department: '',
    reference: '',
    functionField: '',
    customerNumber: '',
    industrySector: '0',
    vatNo: ''
  },
  contactInformation: {
    street: '',
    number: '',
    city: '',
    postCode: '',
    region: null,
    country: null,
    email: '',
    mobile: '',
    phone: ''
  },
  billingAddress: {
    title: '0',
    academicTitle: '1',
    company: '',
    firstName: '',
    lastName: '',
    email: '',
    mobile: '',
    phone: '',
    street: '',
    number: '',
    city: '',
    postCode: '',
    region: null,
    country: null
  },
  communicationAddress: {
    title: '0',
    academicTitle: '1',
    company: '',
    firstName: '',
    lastName: '',
    email: '',
    mobile: '',
    phone: '',
    street: '',
    number: '',
    city: '',
    postCode: '',
    region: null,
    country: null
  }
};

const calculateCommunicationDataChanged = (
  temp,
  homeAddress,
  workEmail,
  mobilePhone,
  homePhone
) => {
  if (
    temp?.firstName !== temp?.communicationData?.firstName ||
    temp?.lastName !== temp?.communicationData?.lastName ||
    temp?.company?.name !== temp?.communicationData?.companyName ||
    workEmail !== temp?.communicationData?.emailDto?.email ||
    mobilePhone !== temp?.communicationData?.mobileDto?.phone ||
    homePhone !== temp?.communicationData?.phoneDto?.phone ||
    homeAddress?.street !== temp?.communicationData?.addressDto?.street ||
    homeAddress?.number !== temp?.communicationData?.addressDto?.number ||
    homeAddress?.city !== temp?.communicationData?.addressDto?.city ||
    homeAddress?.postalCode !== temp?.communicationData?.addressDto?.postalCode ||
    homeAddress?.region?.id !== temp?.communicationData?.addressDto?.region?.id ||
    homeAddress?.country?.id !== temp?.communicationData?.addressDto?.country?.id ||
    temp?.title?.id !== temp?.communicationData?.title?.id
  ) {
    return true;
  } else {
    return false;
  }
};

export const prepopulatedContactInformation = (temp, isEventFree) => {
  if (!temp) return initialValues;

  const homePhone = temp?.phoneDtos.find((item) => item?.type?.id === PhoneTypes.HOME)?.phone;
  const mobilePhone = temp?.phoneDtos.find((item) => item?.type?.id === PhoneTypes.WORK)?.phone;
  const homeAddress = temp?.addressDtos.find((item) => item?.type?.id === AddressTypes.HOME);
  const workEmail = temp?.emailDtos.find((item) => item?.type?.id === EmailTypes.WORK)?.email;

  const areCommunicationDataChanged = calculateCommunicationDataChanged(
    temp,
    homeAddress,
    workEmail,
    mobilePhone,
    homePhone
  );

  return {
    ...initialValues,
    bookingPersonSelectDisabled: true,
    communicationAddressRadio: areCommunicationDataChanged
      ? ADDRESS_OPTIONS.alternative
      : ADDRESS_OPTIONS.noAlternative,
    communicationAddress: areCommunicationDataChanged
      ? {
          title: temp?.communicationData?.title?.id || initialValues?.communicationAddress?.title,
          company: temp?.communicationData?.companyName || '',
          firstName: temp?.communicationData?.firstName || '',
          lastName: temp?.communicationData?.lastName || '',
          email: temp?.communicationData?.emailDto?.email,
          mobile: temp?.communicationData?.mobileDto?.phone,
          phone: temp?.communicationData?.phoneDto?.phone,
          street: temp?.communicationData?.addressDto?.street || '',
          number: temp?.communicationData?.addressDto?.number || '',
          city: temp?.communicationData?.addressDto?.city || '',
          postCode: temp?.communicationData?.addressDto?.postalCode || '',
          region: temp?.communicationData?.addressDto?.region || null,
          country: temp?.communicationData?.addressDto?.country || null
        }
      : initialValues.communicationAddress,
    generalInformation: {
      department: temp?.department || '',
      reference: temp?.customerReference || '',
      functionField: temp?.function || '',
      firstName: temp?.firstName || '',
      lastName: temp?.lastName || '',
      birthDate: formatStringDateForRequest(temp?.birthDate, true) || null,
      birthPlace: temp?.birthPlace || '',
      title: temp?.title?.id || initialValues?.generalInformation?.title,
      gender: temp?.gender?.id || initialValues?.generalInformation?.gender,
      language:
        temp?.nativeLanguage?.id ||
        (isEventFree ? '' : initialValues?.generalInformation?.language),
      company: temp?.company?.name || '',
      customerNumber: '',
      industrySector: '0'
    },
    contactInformation: {
      street: homeAddress?.street || '',
      number: homeAddress?.number || '',
      city: homeAddress?.city || '',
      postCode: homeAddress?.postalCode || '',
      region: homeAddress?.region || null,
      country: homeAddress?.country || null,
      email: workEmail || '',
      mobile: mobilePhone || '',
      phone: homePhone || ''
    }
  };
};

export default initialValues;
